// Função para verificar se o usuário está em um dispositivo móvel baseado na largura da tela
export const isMobileDevice = () => {
  const widthMobile = 768;

  return window.innerWidth < widthMobile;
};
